import { defineComponent as _defineComponent } from 'vue'
import {computed, inject, onMounted, ref} from 'vue';
import NutritionLabelRepository from '@/utils/API/NutritionLabelRepository';
import {CautionaryFrontOfPackRenderData} from '@/models/NutritionLabels/ExportLabelState';
import {FOPLabelFormatData} from '@/models/NutritionLabels/FOPLabelFormatData';
import {LabelTypeMetadata} from '@/models/NutritionLabels/LabelTypeMetadata';
import {SupportedPDS} from '@/models/NutritionLabels/SupportedPDS';
import {useTranslations} from "@/hooks/useTranslations";
import {NutritionCountry} from "@/models/NutritionLabels/NutritionCountry";
import {LabelLanguage} from "@/models/NutritionLabels/LabelLanguage";
import {LabelRenderDto} from "@/models/NutritionLabels/v2/RenderLabelDto";
import {NutritionLabelDownloadFileFormat} from "@/models/NutritionLabels/NutritionLabelDownloadFileFormat";
import CollapsableCard from "@/components/bootstrap/CollapsableCard.vue";
import {ExportLabelView} from "@/models/Cautionary/ExportLabelView";


export default /*#__PURE__*/_defineComponent({
  __name: 'vCautionaryFOPConfig',
  props: {
    labelLanguage: null,
    nutritionCountry: null,
    value: null,
    recipeId: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  labelLanguage: string;
  nutritionCountry: NutritionCountry;
  value: CautionaryFrontOfPackRenderData;
  recipeId: number;
};



const localModel = ref<CautionaryFrontOfPackRenderData>({
  fopFormat: 5,
  pdsSize: 1,
  includeInDownload: true,
});

const labelFormatOptions = ref<FOPLabelFormatData[]>([]);
const pdsSizeOptions = ref<SupportedPDS[]>([]);
const selectedFormat = ref<FOPLabelFormatData>();
const selectedPDS = ref<SupportedPDS>();
const fetchPreviewV2: (renderData: LabelRenderDto, requestingScreen: ExportLabelView) => Promise<Blob> = inject("fetchPreview");

let translations = ref(useTranslations());

const renderModel = computed(() => {
  return {
    country: "Canada",
    labelName: "CautionaryFrontOfPack",
    renderModel: {
      recipeId: props.recipeId,
      labelFormatValue: localModel.value.fopFormat,
      pdsSizeValue: localModel.value.pdsSize,
      labelType: LabelTypeMetadata.CautionaryFrontOfPack
    }
  };
});

expose({
  fetchPreview,
  renderModel
});

onMounted(() => {
  loadLabelFormats();
});

function foPFormatReducer(fopData: FOPLabelFormatData) {
  return fopData.formatValue;
}

function foPPDSReducer(pdsData: SupportedPDS) {
  return pdsData.translationKey;
}

function translate(key: string) {
  return translations.value.get(key);
}

async function loadLabelFormats() {
  if (
    props.nutritionCountry &&
    props.nutritionCountry.name === "Canada"
  ) {
    try {
      const response = await NutritionLabelRepository.getCautionaryFrontOfPackageOptions(
        LabelLanguage[props.labelLanguage]
      );
      labelFormatOptions.value = response.data;

      const savedFormat = labelFormatOptions.value.find(
        (x) => x.formatValue === localModel.value.fopFormat
      );

      updateFOPSelections(savedFormat || labelFormatOptions.value[0]);
    }
    catch (error) {
      console.error("Error loading label formats:", error);
    }
  }
}

function updateFOPSelections(selected: FOPLabelFormatData) {
  selectedPDS.value = selected.supportedPDS.find(
    (x) => x.value === localModel.value.pdsSize
  ) || null;

  selectedFormat.value = selected;
  pdsSizeOptions.value = selected.supportedPDS;
}

async function fetchFOPLabel() {
  await fetchPreviewV2(
    {
      format: NutritionLabelDownloadFileFormat.jpeg,
      ...renderModel.value
    },
    ExportLabelView.CautionaryFOP
  );
}

async function fetchLabelFormats(selected: FOPLabelFormatData) {
  selectedFormat.value = selected;
  localModel.value.fopFormat = selected.formatValue;
  await populatePDSSizes(selected.supportedPDS);
}

async function populatePDSSizes(supportedPDS: SupportedPDS[]) {
  pdsSizeOptions.value = supportedPDS;
  selectedPDS.value = pdsSizeOptions.value[0];

  localModel.value.pdsSize = selectedPDS.value.value;
  await fetchFOPLabel();
}

async function fetchPreview() {
  localModel.value.pdsSize = selectedPDS.value.value || null;
  await fetchFOPLabel();
}

return { __sfc: true,props, localModel, labelFormatOptions, pdsSizeOptions, selectedFormat, selectedPDS, fetchPreviewV2, translations, renderModel, foPFormatReducer, foPPDSReducer, translate, loadLabelFormats, updateFOPSelections, fetchFOPLabel, fetchLabelFormats, populatePDSSizes, fetchPreview, CollapsableCard }
}

})